import { User } from '../../clients/quipli-service/user/user';
import { ReactNode, useCallback } from 'react';
import { debounce } from 'lodash';
import { useAPI } from '../../clients/quipli-service/quipli-service-client';
import { Location } from '../../clients/quipli-service/location/location';
import { AsyncSelectForm } from '../select-form/select-form';
import { components } from 'react-select';
import { Typography } from '../typography/typography';
import { toast } from '../../util/toasts';

export const UserSearch = ({
  locations,
  selectedUser,
  placeholder = 'Select',
  excludeUserIds,
  searchBy = 'keyword',
  onSelectUser,
  formatSelected,
  formatOptions,
}: {
  locations: Location[];
  selectedUser?: User;
  placeholder?: string;
  excludeUserIds?: number[];
  searchBy?: 'email' | 'keyword';
  onSelectUser: (user?: User) => void;
  formatSelected?: (user: User) => ReactNode;
  formatOptions?: (user: User) => ReactNode;
}) => {
  const { searchUsers } = useAPI();

  const getUsers = useCallback(
    debounce(function (value: string, callback) {
      searchUsers({
        [searchBy]: value,
        excludeUserIds,
        pageNumber: 1,
        pageSize: 10,
      })
        .then((response) => callback(response.items))
        .catch(() => toast('Failed to search users', 'error'));
    }, 500),
    [locations, selectedUser],
  );

  return (
    <AsyncSelectForm
      cacheOptions
      defaultOptions
      loadOptions={getUsers}
      className="w-full break-all"
      value={selectedUser}
      getOptionValue={(user) => user?.id.toString()}
      onChange={(user) => onSelectUser(user || undefined)}
      loadingMessage={() => 'Loading...'}
      noOptionsMessage={() => 'No customers found'}
      isClearable={true}
      placeholder={placeholder}
      menuPlacement="auto"
      components={{
        SingleValue: ({ ...props }) => (
          <components.SingleValue {...props}>
            {formatSelected ? formatSelected(props.data) : <Typography type="text-sm">{props.data.name}</Typography>}
          </components.SingleValue>
        ),
        Option: ({ ...props }) => (
          <components.Option {...props}>
            {formatOptions ? formatOptions(props.data) : <Typography type="text-sm">{props.data.name}</Typography>}
          </components.Option>
        ),
      }}
    />
  );
};
